
var App = App || {};

(function(ns, $) {
    function getReferencesFromDom() {

        var referencesArray = [];

        // A list of references could exist multiple times on the same page but only one copy is needed.
        var $references = $('div.ref-list').first().find('div.ref-content');
        $references.each(function() {
            // create a jQuery object from the dom element
            var $reference = $(this);
            // json object to append to the array
            var item = {};

            // the role is the unique id for the reference
            item.referenceId = $reference.attr('role');

            // if there's a doi, that's all that we care about
            // skip the rest of the dom parsing for this item
            var doi = $reference.find('.mixed-citation .crossref-doi > a').attr('href');
            if (doi) {
                item.doi = doi.slice(18);
            } else {
                setPropertyFromDomValue(item, $reference, '.publisher-name', 'publisher');
                setPropertyFromDomValue(item, $reference, '.source', 'journal');
                setPropertyFromDomValue(item, $reference, '.volume', 'volume');
                setPropertyFromDomValue(item, $reference, '.issue', 'issue');
                setPropertyFromDomValue(item, $reference, '.fpage', 'startPage');
                setPropertyFromDomValue(item, $reference, '.issn', 'issn');
                setPropertyFromDomValue(item, $reference, '.eissn', 'eissn');
            }
            referencesArray.push(item);
        });

        return referencesArray;
    }

    function setPropertyFromDomValue(item, $reference, selector, propertyName) {
        var value = getReferenceDomNode($reference, selector);
        if (value) {
            item[propertyName] = value;
        }
    }

    function getReferenceDomNode($reference, selector) {
        return $reference.find('.mixed-citation ' + selector).text();
    }

    function findMatchingGeoRefContent(domJson) {
        ajaxUrl = (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/GSW/GetGeoRefEnhancements/GetGeoRefEnhancementsRelated';

        var hashCode = buildHashCode(JSON.stringify(domJson));

        $.ajax({
            async: true,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                cacheHash: hashCode,
                contentQueryItems: domJson
            }),
            url: ajaxUrl,
            type: 'POST',
            success: function (json) {
                generateGeoRefLinks(json);
            },
            error: function (xhr, textStatus, errorThrown) {
                console.log('The request to the GetGeoRefEnhancements widget has failed.' + textStatus);
                console.log(xhr);
                console.log(textStatus);
                console.log(errorThrown);
            }
        });
        return null;
    }
    
    // use the json to match reference dom items and add a georef link
    function generateGeoRefLinks(geoRefLinks) {
        for (var i = 0; i < geoRefLinks.length; i++) {
            var link = geoRefLinks[i];
            // find the reference node(s)
            var $reference = $('div.ref-content[role="' + link.ReferenceId + '"]');
            // find the citation section
            var $referenceCitation = $reference.find('.citation-links');
            if (!$referenceCitation.children('.georef-link').length) {
                // build the new dom node to add
                var newDomNode = '<div class="georef-link"><a href="' + link.Href + '">GeoRef</a></div>';
                // append it to the end of the set of children
                $referenceCitation.append(newDomNode);
            }
        }
    }

    // There's a limit to how large a json request can be
    var batchSize = 323;
    function buildReferenceLinks() {
        var referencesArray = getReferencesFromDom();
        if (referencesArray) {
            while (referencesArray.length) {
                var nextRefBatch = referencesArray.slice(0, batchSize);
                findMatchingGeoRefContent(nextRefBatch);
                referencesArray = referencesArray.slice(batchSize);
            }
        }
    }

    function buildHashCode(str) {
        var hash = 0;
        if (str.length === 0) return hash;
        for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash.toString();
    }
    ns.init = function () {
        // Use setTimeout so we don't block the thread and freeze rendering
        setTimeout(buildReferenceLinks, 0);
    };


})(App.GeoRefReferenceLinks = App.GeoRefReferenceLinks || {}, jQuery);

(function() {
    $(document).ready(function() {
        App.GeoRefReferenceLinks.init(); // init general JS module for site
    });
})();